module.exports = __webpack_public_path__ + "media/images/samples/home/ig1-ec774035992640e40c18d87a09c798f6.png";